import { combineReducers } from 'redux';

import agreementReducer from './agreement/agreementReducer.js';
import noOpReducer from '../noOpReducer.js';
import paymentReducer from './payment/paymentReducer.js';
import safeTradeReducer from './safeTradeReducer.js';

export default combineReducers({
    agreement: agreementReducer,
    partner: noOpReducer,
    payment: paymentReducer,
    safeTrade: safeTradeReducer,
    user: noOpReducer,
    withdrawal: noOpReducer,
});



// WEBPACK FOOTER //
// ./safeTrade/seller/reducer.js